import { Fragment,useContext,useEffect, useState } from 'react'
import { ConfigProvider } from 'antd';
import { createBrowserHistory } from "history";
import {

    Routes,
    Route,
    useLocation
  } from "react-router-dom";



import { Login } from './screens/login';
import MngHome from './screens/adminManagement';
import NotMatch from './screens/notMatch';
import MngUniversities from './screens/adminManagement/mngUniversities';
import { appIdentifier, getLocal } from './globalFunctions/api';
import { GlobalContext } from './contexts/GlobalContext';
import { ProtectedRoute } from './ProtectedRoute';
import MngColleges from './screens/adminManagement/mngColleges';
import MngDeparts from './screens/adminManagement/mngDeparts';
import MngInfos from './screens/adminManagement/mngInfos';
import MngAdmins from './screens/adminManagement/mngMngAdmins';
import MngSendToTeacher from './screens/adminManagement/mngSendToTeacher';
import MngThesis from './screens/adminManagement/mngThesis';
import MngTeacherThesis from './screens/adminManagement/mngTeacherThesis';






export default function AppNavigator() {

  const {loggedIn,setLoggedIn,} = useContext(GlobalContext);
  const [loading, setLoading] = useState(true)
  const localUserType = getLocal(appIdentifier)?.user?.user_type || null 
  const location = useLocation();
  useEffect(() => {
    
    const token = getLocal(appIdentifier)?.jwt|| ''
    if (token) {
      setLoggedIn(true);
      setLoading(false);
    }else{
      setLoggedIn(false);
      setLoading(false);
    }
    
  }, [location])

  
  


  return (
   <Fragment>
     {
       loading?
       <div
         style={{
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           height: "100vh",
           flexDirection: "column",
         }}
       >
         <p>Loading....</p>
       </div>
       :
        <ConfigProvider direction='rtl'  >
              
                  <Routes>
                      <Route path='/' exact  element={<Login/>} /> 
                      <Route path='/login' exact element={<Login/>} /> 

                      <Route path='/mnghome' exact element={<ProtectedRoute><MngHome/></ProtectedRoute> } /> 
                      {
                        localUserType === 'main'&&<Route path='/unviversities' exact element={<ProtectedRoute><MngUniversities/></ProtectedRoute>} /> 
                      }

                      {
                        (localUserType === 'university' || localUserType === 'main') &&<Route path='/colleges' exact element={<ProtectedRoute><MngColleges/></ProtectedRoute>} /> 
                      }

                      {
                        (localUserType === 'college' || localUserType === 'main')&&<Route path='/departs' exact element={<ProtectedRoute><MngDeparts/></ProtectedRoute>} /> 
                      }
                      

                      <Route path='/infos' exact element={<ProtectedRoute><MngInfos/></ProtectedRoute>} /> 
                      <Route path='/admins' exact element={<ProtectedRoute><MngAdmins/></ProtectedRoute>} /> 
                      {
                        localUserType === 'depart'&&<Route path='/send_to_teacher' exact element={<ProtectedRoute><MngSendToTeacher/></ProtectedRoute>} /> 
                      }

                      {
                        localUserType === 'depart'&&<Route path='/mng_thesis' exact element={<ProtectedRoute><MngThesis/></ProtectedRoute>} /> 
                      }

                      {
                        localUserType === 'teacher'&&<Route path='/mng_teacher_thesis' exact element={<ProtectedRoute><MngTeacherThesis/></ProtectedRoute>} /> 
                      }
                     
                     
                      
                      <Route path='*' exact element={<NotMatch/>} /> 
                  </Routes>
              

        </ConfigProvider>

     }
       
   </Fragment>
  )
}



